import { reactive, watchEffect } from 'vue'

const AInputRenderless = (props, ctx) => {
    let store = reactive({
        state: {
            filled: false,
            dragover: false,
            error: props.error,
            ...props.state,
        },
    })

    const autogrow = (reactiveControl) => {
        if (reactiveControl.value) {
            if (reactiveControl.value.scrollHeight > reactiveControl.value.clientHeight) {
                reactiveControl.value.style.height = `${reactiveControl.value.scrollHeight + 10}px`
            }
        }
    }

    watchEffect(() => {
        props.modelValue || props.modelValue === 0 ? (store.state.filled = true) : (store.state.filled = false)
    })

    const numberType = (e) => {
        if (!/[0-9]|[.,]/.test(e.key)) {
            e.preventDefault()
        }

        if (/[.,]/.test(e.key)) {
            if (/[.,]/.test(e.target.value)) {
                e.preventDefault()
            }
        }

        if (!/^(0$|-?[1-9]\d*(\.\d*[1-9]$)?|-?0\.\d*[1-9])$/.test(e.target.value) && e.target.value !== '' && !/\.$/.test(e.target.value)) {
            e.preventDefault()
        }
    }

    // only Lat letters, numbers and spec. symbols
    const validateLat = (e) => {
        if(!/^[A-Za-z0-9\s!@#$%^&*()_+=-`~\\\]\[{}|';:/.,?><]*$/.test(e.key)) {
            e.preventDefault()
            return false
        }

        return true
    }

    return {
        store,
        autogrow,
        numberType,
        validateLat,
    }
}

export { AInputRenderless }
